import CardHoverInfo from '../CardHoverInfo';
import TarotCard from '../TarotCard';
import './CareerSpread.css';

/** The career layout: the dealt cards in their positions. */
function CareerSpread({ spread, cards, revealed, onReveal }) {
  return (
    <div className="career-layout">
      {cards.map((card, index) => {
        const position = spread.positions[index];
        const isRevealed = revealed.includes(index);

        return (
          <div
            key={index}
            className={`card-position ${isRevealed ? 'revealed' : ''}`}
            onClick={() => onReveal(index)}
          >
            <div className="position-label">
              <span className="position-number">{position.id}</span>
              <span className="position-name">{position.name}</span>
            </div>
            <CardHoverInfo card={card}>
              <TarotCard card={card} isRevealed={isRevealed} />
            </CardHoverInfo>
            <div className="position-description">
              {position.description}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default CareerSpread;
